<template>
  <div class = 'score-bar'>
    <div class = 'score-desc'>
      <span class = 'begin-desc'>{{beginDesc}}</span>
      <span class = 'end-desc'>{{endDesc}}</span>
    </div>
    <ul class = 'score-list'>
      <li v-for = '(item,index) of scoreLength' :key = 'index' class = 'score-block'
         @click= 'changeScore(index)'
      :class = '{"active": index <= score}' :style = "scoreActiveStyle(index)" >{{index}}</li>
    </ul>
  </div>
</template>
<script>
import {
  hexToRgba
} from '../utils/utils'
export default {
  props: {
    beginDesc: {
      default: ''
    },
    endDesc: {
      default: ''
    },
    scoreLength: {
      default: 11
    },
    themeColor: {
      default: 'rgb(255, 85, 45, 1)'
    },
    activeScore: {
      default: -1
    }
  },
  data() {
    return {
      score: -1
    }
  },
  created() {
    this.score = this.activeScore
  },
  watch: {
    'activeScore'(val) {
      this.score = val
    }
  },
  methods: {
    changeScore(index) {
      this.score = index
      this.$emit('changeScore', index)
    },
    scoreActiveStyle(index) {
      if (index <= this.score) {
        const opacityStep = 1 / (this.score + 2)
        const opacity = (index + 2) * opacityStep
        let color = this.themeColor
        if (this.themeColor.indexOf('#') === 0) {
          color = hexToRgba(this.themeColor, 1)
        }
        const colorMap = color.match(/(\d+),\s*(\d+),\s*(\d+),\s*((?:0?\.\d+)|1)/)
        return { 'background-color': `rgba(${colorMap[1]}, ${colorMap[2]}, ${colorMap[3]}, ${opacity})` }
      } else {
        return {}
      }
    }
  }
}
</script>
<style lang="scss">
.score-bar {
  .score-desc {
    font-size: 14px;
    color: $font-color-default;
    line-height: 20px;
    .begin-desc {
      float: left;
    }
    .end-desc {
      float: right;
    }
  }

  .score-list {
    display: flex;
    flex-wrap: nowrap;
    width: 100%;
    padding-top: 10px;
    .score-block {
      flex: 1;
      height: 36px;
      line-height: 34px;
      border: 1px solid $border-color-default;
      border-radius: 2px;
      color: #666666;
      text-align: center;
      margin-right: 11px;
      background-color: #ffffff;
      cursor: pointer;
      &:last-child {
        margin-right: 0;
      }
      &.active {
        border-color: rgba(0,0,0,0);
        color: #ffffff;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/scoreBar.vue